import {IonicModule} from '@ionic/angular';
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';

import {ImageMaskComponent} from './image-mask/image-mask.component';
import {InlineSVGModule} from 'ng-inline-svg';
import {BaseModule} from '../base/base.module';

@NgModule({
    imports: [
        CommonModule,
        BaseModule,
        InlineSVGModule.forRoot(),
    ],
    declarations: [ImageMaskComponent],
    exports: [ImageMaskComponent]
})
export class ConfiguratorModule {
}
